<template>
  <div>
    <div v-if="note">
      <ul class="noteList">
        <li>{{ note }}</li>
        <!-- <li v-show="false" ref="noteId">{{ n.id }}</li> -->
        <li><button class="btn" @click="removeNote">Remove Note</button></li>
      </ul>
    </div>
  </div>
</template>

<script>
   
    export default { 
        props: [ 'parentId', 'noteId', 'note' ],
        data() {
            return {
         //   noteId: ''
            }

            
        },

      //  created() {
      //      console.log('group', this.group)
      //  },
        
      computed: {
        group () {
          return this.$store.getters['groups/groups'].find(group => group.id === this.parentId)
        },

        notes () {
          return this.$store.getters['groups/groups'].find(group => group.id === this.parentId).notes
        }
      },

       methods: {
           removeNote(){
             // const noteId = this.$refs.noteId.textContent
               this.$store.dispatch('groups/removeNote', {id: this.parentId, noteId: this.noteId })
           }
       }

    }
</script>

<style scoped>
li {
  list-style: none;
  margin-top: 0.5rem;
}

.noteList {
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  text-align: left;
  padding: none;
  padding: 0px;
}
.btn {
  background-color: #d29b9b;
  color: white;
  padding: 0.5rem;
  border: none;
  border-radius: 0.3rem;
  width: 11em;
  font-size: 1em;
  cursor: pointer;
}
</style>